import { render, staticRenderFns } from "./inform-userUnread.vue?vue&type=template&id=55869205&scoped=true"
import script from "./inform-userUnread.vue?vue&type=script&lang=js"
export * from "./inform-userUnread.vue?vue&type=script&lang=js"
import style0 from "./inform-userUnread.vue?vue&type=style&index=0&id=55869205&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2f37ed56e32c39bf37bd07aa5cbb5c73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55869205",
  null
  
)

export default component.exports